import {
  SCHEME_LIST,
  SCHEME_GET,
  SCHEME_CREATE,
  SCHEME_UPDATE,
  SCHEME_PAUSE,
  SCHEME_RESUME,
  SCHEME_ARCHIVE,
  SCHEME_REORDER,
  SCHEME_EVALUATE,
} from "../types";

export const schemeListAction = (data, onSuccess, onError) => ({
  type: SCHEME_LIST,
  data,
  onSuccess,
  onError,
});

export const schemeGetAction = (data, onSuccess, onError) => ({
  type: SCHEME_GET,
  data,
  onSuccess,
  onError,
});

export const schemeCreateAction = (data, onSuccess, onError) => ({
  type: SCHEME_CREATE,
  data,
  onSuccess,
  onError,
});

export const schemeUpdateAction = (data, onSuccess, onError) => ({
  type: SCHEME_UPDATE,
  data,
  onSuccess,
  onError,
});

export const schemePauseAction = (data, onSuccess, onError) => ({
  type: SCHEME_PAUSE,
  data,
  onSuccess,
  onError,
});

export const schemeResumeAction = (data, onSuccess, onError) => ({
  type: SCHEME_RESUME,
  data,
  onSuccess,
  onError,
});

export const schemeArchiveAction = (data, onSuccess, onError) => ({
  type: SCHEME_ARCHIVE,
  data,
  onSuccess,
  onError,
});

export const schemeReorderAction = (data, onSuccess, onError) => ({
  type: SCHEME_REORDER,
  data,
  onSuccess,
  onError,
});

export const schemeEvaluateAction = (data, onSuccess, onError) => ({
  type: SCHEME_EVALUATE,
  data,
  onSuccess,
  onError,
});
